export default __webpack_public_path__ + "static/blob-38-d2f143266925bc1bf8014f9958c07bba.svg";